<template>
    <div class="e-profileactions">
        <ul>
            <li v-if="isLoggedIn">{{likeCount}} {{likeCount == 1 ? 'Like' : 'Likes'}}</li>
            <li>
                <button v-bind:class="{ selected: isLiked }" v-on:click.prevent="toggleLiked" v-if="!loading" :disabled="toggling">
                    <span>{{isLiked ? 'Liked' : 'Like'}}</span>
                    <svg class="user-action-icon" aria-hidden="true" viewBox="0 0 20 17.364">
                        <path d="M4.318,6.318a4.5,4.5,0,0,0,0,6.364L12,20.364l7.682-7.682a4.5,4.5,0,0,0-6.364-6.364L12,7.636,10.682,6.318A4.5,4.5,0,0,0,4.318,6.318Z"
                        transform="translate(-2 -4)" stroke="#358636" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" />
                    </svg>
                </button>
            </li>
            <li>
                <button v-bind:class="{ selected: isSaved }" v-on:click.prevent="toggleSaved" v-if="!loading" :disabled="toggling">
                <span>{{isSaved ? 'Saved' : 'Save'}}</span>
                <svg class="user-action-icon" aria-hidden="true" viewBox="0 0 16 20">
                    <path d="M5,5A2,2,0,0,1,7,3H17a2,2,0,0,1,2,2V21l-7-3.5L5,21Z"
                            transform="translate(-4 -2)" stroke="#318731" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2" />
                </svg>
            </button>
            </li>
        </ul>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Axios from 'axios'

    export default {
        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            },

            loginPage: function () {
                return loginPage
            },

            registerPage: function () {
                return registerPage
            },
            shouldLoadComponent() {
                const allowedHostname = 'hie.co.uk'
                return window.location.hostname.includes(allowedHostname)
            },
        },

        created: function () {
            if (this.shouldLoadComponent) {
                this.init()
            }
        },

        data() {
            return {
                isLiked: false,
                isSaved: false,
                likeCount: 0,
                loading: true,
                showAlert: false,
                toggling: false
            }
        },

        methods: {
            init: function () {
                const vm = this
                const hasLikes = function () {
                    return Axios.get('/umbraco/api/LikedPageApi/HasLikedPage', { params: { pageId: vm.pageId } })
                }

                Axios.defaults.headers = {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }

                Axios.all([hasLikes()])
                    .then(Axios.spread(function (response) {

                        if (response.data) {
                            vm.isLiked = response.data.IsLiked
                            vm.likeCount = response.data.LikeCount
                        }
                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })

                const hasSaved = function () {
                    return Axios.get('/umbraco/api/SavedPageApi/HasSavedPage', { params: { pageId: vm.pageId } })
                }

                Axios.all([hasSaved()])
                    .then(Axios.spread(function (response) {

                        if (response.data) {
                            vm.isSaved = response.data
                        }
                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            toggleLiked: function () {
                const vm = this
                vm.toggling = true

                const toggleLiked = function () {
                    return Axios.get('/umbraco/api/LikedPageApi/ToggleLikedPage', { params: { pageId: vm.pageId } })
                }

                Axios.all([toggleLiked()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.isLiked = response.data.IsLiked
                            vm.likeCount = response.data.LikeCount

                            if (vm.likesSavesContainer.is(':hidden')) {
                                vm.likesSavesContainer.show()
                            }

                            if (vm.likesSavesMark.is(':hidden')) {
                                vm.likesSavesMark.show()
                            }

                            var totalLikesCount = parseInt(vm.totalLikes[0].innerHTML)

                            if (vm.totalLikes && response.data.IsLiked) {
                                vm.totalLikes.each(function () {
                                    $(this).text(totalLikesCount + 1)
                                })
                            }
                            else {
                                vm.totalLikes.each(function () {
                                    $(this).text(totalLikesCount - 1)
                                })
                            }

                            if (vm.totalLikes[0].innerHTML === '0' && vm.totalSaves[0].innerHTML === '0') {
                                vm.likesSavesContainer.hide()
                                vm.likesSavesMark.hide()
                            }
                        }
                        vm.loading = false
                        vm.toggling = false

                        setTimeout(function () {
                            vm.likesSavesMark.addClass('pulse')
                            setTimeout(function () {
                                vm.likesSavesMark.removeClass('pulse')
                            }, 4000)
                        }, 500)
                    }))
                    .catch(() => {
                        vm.loading = false
                        vm.toggling = false
                    })
            },

            toggleSaved: function () {
                const vm = this
                vm.toggling = true

                const toggleSaved = function () {
                    return Axios.get('/umbraco/api/SavedPageApi/ToggleSavedPage', { params: { pageId: vm.pageId } })
                }

                Axios.all([toggleSaved()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.isSaved = response.data

                            if (vm.likesSavesContainer.is(':hidden')) {
                                vm.likesSavesContainer.show()
                            }

                            if (vm.likesSavesMark.is(':hidden')) {
                                vm.likesSavesMark.show()
                            }

                            var totalSavesCount = parseInt(vm.totalSaves[0].innerHTML)

                            if (vm.totalSaves && response.data) {
                                vm.totalSaves.each(function () {
                                    $(this).text(totalSavesCount + 1)
                                })
                            }
                            else {
                                vm.totalSaves.each(function () {
                                    $(this).text(totalSavesCount - 1)
                                })
                            }

                            if (vm.totalLikes[0].innerHTML === '0' && vm.totalSaves[0].innerHTML === '0') {
                                vm.likesSavesContainer.hide()
                                vm.likesSavesMark.hide()
                            }
                        }
                        vm.loading = false
                        vm.toggling = false

                        setTimeout(function () {
                            vm.likesSavesMark.addClass('pulse')
                            setTimeout(function () {
                                vm.likesSavesMark.removeClass('pulse')
                            }, 4000)
                        }, 500)
                    }))
                    .catch(() => {
                        vm.loading = false
                        vm.toggling = false
                    })
            }
        },

        mounted: function () {
            const vm = this
            if (this.shouldLoadComponent) {
                vm.init()
            }
            vm.totalLikes = $('.totalLikes')
            vm.totalSaves = $('.totalSaves')
            vm.likesSavesContainer = $('.e-likesSaves')
            vm.likesSavesMark = $('.h-myhielink .e-warning')
        },

        props: {
            pageId: {
                required: true,
                type: String
            }
        },

        watch: {
            pageId: function () {
                if (this.shouldLoadComponent) {
                    this.init()
                }
            }
        }
    }
</script>
